import {
	ADD_NEW_CLINIC_REQUEST,
	ADD_NEW_CLINIC_SUCCESS,
	ADD_NEW_CLINIC_FAILURE
} from "../../../constants"

const initialState = {
	loading: false,
	data: null,
	error: null,
}

const addNewClinicReducer = (state = initialState, action) => {
	switch (action.type) {
		case ADD_NEW_CLINIC_REQUEST:
			return {
				...state,
				loading: true,
				error: null,
				data: null,
			};
		case ADD_NEW_CLINIC_SUCCESS:
			return {
				...state,
				loading: false,
				data: action.payload,
				error: null,
			}
		case ADD_NEW_CLINIC_FAILURE:
			return {
				...state,
				loading: false,
				error: action.payload,
				data: null
			}
		default:
			return state;
	}
}
export default addNewClinicReducer